(ns hai.ui.components.card
  "Card container component"
  #?(:cljs (:require-macros hai.ui.components.card))
  (:require
   [hai.ui.components.new-design.utils :refer [px->rem]]
   [hai.ui.icons :as icons]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]))

(o/defstyled container-gap :_mixin
  {:gap (px->rem 16)})

(o/defstyled frame :div
  container-gap
  {:display "flex"
   :padding (px->rem 16)
   :border (str "1px solid " t/--text-secondary-20)
   :color t/--text-secondary-50
   :border-radius (px->rem 8)
   :background-color t/--bg-1})

(o/defstyled grid :div
  :grid :gap-4
  {:grid-template-columns "repeat(auto-fill, minmax(300px, 1fr))"})

(o/defstyled field :div
  :flex :flex-col :gap-1
  [:.label {:font-size "0.75rem"
            :color t/--gray-10
            :line-height "1rem"}]
  [:.value {:font-size "0.875rem"
            :line-height "1.25rem"}])

(o/defstyled fields-layout :div
  :flex :flex-col {:gap "0.75rem"})

(o/defstyled checkbox :div
  :absolute {:top "0.75rem" :right "0.75rem" :z-index "1"})

(o/defstyled header :div
  :flex :flex-col :space-y-1.5 :p-6)

(o/defstyled title :div
  :font-semibold :leading-none :tracking-tight :flex :justify-between)

(o/defstyled description :div
  :text-sm)

(o/defstyled content :div
  :p-6 :pt-0)

(o/defstyled footer :div
  :flex :items-center :p-6 :pt-0)

;; ── Solution card components ──────────────────────────────────────────────────
;; NOTE this is mostly claude generated, YMMV... YOLO

(o/defstyled edit-overlay :span
  :absolute :cursor-pointer
  {:top (px->rem 16)
   :right (px->rem 16)
   :opacity "0"
   :transition "opacity 0.15s"
   :color t/--colour-rock}
  [:&:hover {:color t/--colour-purple}])

(o/defstyled card-hover :_mixin
  :cursor-pointer
  {:transition "box-shadow 0.2s, transform 0.15s"}
  [:&:hover
   {:box-shadow "0 4px 20px rgba(30, 8, 93, 0.08)"
    :transform "translateY(-2px)"}
   [edit-overlay {:opacity "1"}]])

(o/defstyled card-focus :_mixin
  [:&:focus-visible
   {:outline (str "2px solid " t/--colour-purple)
    :outline-offset "2px"}])

(o/defstyled card :article
  :flex :flex-col :relative
  {:background-color t/--colour-snow
   :border-radius (px->rem 12)
   :padding (px->rem 24)
   :gap (px->rem 8)
   :transition "box-shadow 0.2s, transform 0.15s"}
  card-hover
  card-focus)

(o/defstyled badges :div
  :flex :flex-wrap
  {:gap "6px"
   :min-height (px->rem 24)})

(o/defstyled badge :span
  :inline-flex :items-center
  {:gap "4px"
   :font-size (px->rem 12)
   :font-weight "500"
   :padding [(px->rem 4) (px->rem 12)]
   :border-radius "9999px"
   :width "fit-content"
   :background-color t/--colour-chalk
   :color t/--text-secondary})

(o/defstyled solution-title :h3
  {:font-size (px->rem 18)
   :font-weight "600"
   :color t/--text-secondary
   :line-height "1.2"})

(o/defstyled solution-description :p
  :overflow-hidden
  {:font-size (px->rem 16)
   :font-weight "400"
   :color t/--text-secondary
   :opacity "0.8"
   :line-height "1.5"
   :display "-webkit-box"
   :-webkit-line-clamp "2"
   :-webkit-box-orient "vertical"})

(o/defstyled solution-footer :div
  :flex :items-center :justify-between
  {:margin-top (px->rem 8)
   :padding-top (px->rem 16)
   :border-top (str "1px solid " t/--colour-chalk)})

(o/defstyled tool-indicator :span
  :flex :items-center
  {:gap "4px"
   :font-size (px->rem 14)
   :font-weight "500"
   :color t/--text-secondary
   :opacity "0.65"}
  [:.dot {:width "6px"
          :height "6px"
          :border-radius "50%"
          :background-color "#D4C1F6"}])

(o/defstyled meta-info :span
  :flex :items-center
  {:gap "6px"
   :font-size (px->rem 14)
   :font-weight "400"
   :color t/--text-secondary
   :opacity "0.65"}
  [:svg {:flex-shrink "0"}]
  ([& children]
   #?(:cljs
      (into [:<> [icons/outlined-access_time]] children))))

(o/defstyled card-top-row :div
  :flex :items-center :justify-between
  {:min-height "20px"
   :margin "-1rem -1rem -0.5rem -1rem"})

(o/defstyled solution-grid :div
  :grid
  {:grid-template-columns "repeat(auto-fill, minmax(280px, 1fr))"
   :gap (px->rem 16)})
